import { render, staticRenderFns } from "./JitsiIframe.vue?vue&type=template&id=2e79e92f&scoped=true&"
import script from "./JitsiIframe.vue?vue&type=script&lang=js&"
export * from "./JitsiIframe.vue?vue&type=script&lang=js&"
import style0 from "./JitsiIframe.vue?vue&type=style&index=0&id=2e79e92f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e79e92f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e79e92f')) {
      api.createRecord('2e79e92f', component.options)
    } else {
      api.reload('2e79e92f', component.options)
    }
    module.hot.accept("./JitsiIframe.vue?vue&type=template&id=2e79e92f&scoped=true&", function () {
      api.rerender('2e79e92f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JitsiIframe.vue"
export default component.exports